import React from 'react';
import {Stack, Typography} from "@mui/material";
import TagChip from './TagChip';
import NewTagInput from './NewTagInput';
import BookmarksRoundedIcon from '@mui/icons-material/BookmarksRounded';

export default function TagList({
                                    tags = [],
                                    createTag,
                                    voteTag,
                                    isPosting,
                                    loadingTagOps,
                                    docId,
                                    searchTagsFn = null,
                                    onTagClick = null,
                                    showAdd = true,
                                }) {
    return (
        <Stack
            direction={'row'}
            alignItems={'center'}
            gap={1}
            flexWrap={'wrap'}
            sx={{
                transition: 'all 0.15s ease-in-out'
            }}
        >
            <BookmarksRoundedIcon
                fontSize={'12px'}
                sx={{
                    color: 'rgba(156, 39, 176, .8)',
                }}
            />
            {tags.length === 0 ? (
                <Typography variant={'body2'} color={'text.secondary'}>No tags</Typography>
            ) : (
                tags.map(t => (
                    <TagChip
                        key={t.name}
                        tag={t}
                        voteTag={voteTag}
                        loadingTagOps={loadingTagOps}
                        onTagClick={onTagClick}
                    />
                ))
            )}

            {/* Create new tag input (hidden behind plus) */}
            {showAdd && createTag && (
                <Stack
                    direction={'row'}
                    gap={1}
                    alignItems={'center'}
                    onClick={(e) => e.stopPropagation()}
                >
                    <NewTagInput createTag={createTag} isPosting={isPosting} existingTags={tags} docId={docId} searchTagsFn={searchTagsFn}/>
                </Stack>
            )}
        </Stack>
    );
}
